import api from "./Api";
import { PORTS } from "../config/modulePort";
import { PICKLIST_GROUP_NAME } from "../common/Constant";
const PickList_URL = process.env.REACT_APP_PICKLIST_URL || "";

const INJURY_URL = process.env.REACT_APP_CASE_URL || "";
// Default to an empty string or another default value
const PickListGroup = api(PickList_URL);
const InjuryAPI = api(INJURY_URL);
export const AddInjury = async (injuryData: any): Promise<any> => {
  try {
    // console.log("🚀 Sending Injury Data:", injuryData);

    const response = await InjuryAPI.post(
      "/api/case/subject/injury/add",
      injuryData
    );

    console.log("✅ Injury Added Successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error(
      "API Error:",
      error.response ? error.response.data : error.message
    );

    throw new Error(
      error.response?.data?.message || "Unable to add injury. Please try again."
    );
  }
};

export const FetchNatureOfInjury = async (): Promise<any[]> => {
  try {
    const response = await PickListGroup.post(
      `/api/picklist/items/bygroupname`,
      {
        groupName: PICKLIST_GROUP_NAME.Nature_of_Injury,
        triggerById: 0,
      }
    );

    if (response.data.isSuccess) {
      return response.data.result.map((item: any) => ({
        value: item.pickListItemId,
        label: item.displayName,
      }));
    } else {
      console.error("Error fetching Nature_of_Injury:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("API error:", error);
    return [];
  }
};
export const FetchSaverityOfInjury = async (): Promise<any[]> => {
  try {
    const response = await PickListGroup.post(
      `/api/picklist/items/bygroupname`,
      {
        groupName: PICKLIST_GROUP_NAME.SeverityOf_Injury,
        triggerById: 0,
      }
    );

    if (response.data.isSuccess) {
      return response.data.result.map((item: any) => ({
        value: item.pickListItemId,
        label: item.displayName,
      }));
    } else {
      console.error("Error fetching Nature_of_Injury:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("API error:", error);
    return [];
  }
};
export const FetchInjuryType = async (): Promise<any[]> => {
  try {
    const response = await PickListGroup.post(
      `/api/picklist/items/bygroupname`,
      {
        groupName: PICKLIST_GROUP_NAME.Injury_Type,
        triggerById: 0,
      }
    );

    if (response.data.isSuccess) {
      return response.data.result.map((item: any) => ({
        value: item.pickListItemId,
        label: item.displayName,
      }));
    } else {
      console.error("Error fetching Nature_of_Injury:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("API error:", error);
    return [];
  }
};
export const FetchInjuryDetails = async (
  caseSubjectId: number | null
): Promise<any> => {
  try {
    const response = await InjuryAPI.get(`/api/case/subject/injury/details`, {
      params: { caseSubjectId },
    });

    //console.log("✅ Raw API Response:", response.data); // Debugging API Response

    // Ensure the response contains an array inside `result`
    if (
      !response.data ||
      !response.data.result ||
      !Array.isArray(response.data.result)
    ) {
      console.error("❌ Unexpected API response format:", response.data);
      throw new Error("Invalid API response: Expected an array in 'result'.");
    }

    // Add Edit action to each injury detail entry
    const updatedResult = response.data.result.map((injury: any) => ({
      ...injury,
      actions: { Edit: "Edit" }, // Adding Edit action inside each object
    }));
    // console.log(updatedResult, "updatedResultupdatedResultupdatedResult");

    return { ...response.data, result: updatedResult }; // Return updated response
  } catch (error: any) {
    console.error(
      "API Error:",
      error.response ? error.response.data : error.message
    );

    throw new Error(
      error.response?.data?.message ||
        "Unable to fetch injury details. Please try again."
    );
  }
};

export const updateInjuryDetails = async (
  caseSubjectInjuryId: any,
  payload: any
) => {
  try {
    console.log("🛠 Updating injury details:", { caseSubjectInjuryId, payload });

    const response = await InjuryAPI.put(
      `/api/case/subject/injury/Update`, // ✅ Correct API endpoint
      { caseSubjectInjuryId, ...payload } // ✅ Send data in the request body
    );

    console.log("✅ Update successful:", response.data);
    return response.data;
  } catch (error: any) {
    console.error(
      "❌ Error updating injury details:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to update injury details"
    );
  }
};
